import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { SpinnerClass } from "core/classes/spinner.class";

let spinnerOptions = function() {
  return {
    classes: {
      disablePopup: "disablePopup",
      redirect: "redirect",
      popupClass: "abacusPopup",
      popupContentClass: ".abacusPopupContent",
      popupCloseClass: "closePopup",
      activatePopup: "show",
      bodyClass: "popupActivated",
      loaderClass: "loading"
    }
  };
};

class NewsletterSignup extends Class {
  constructor(element) {
    super();
    this.setOptions(spinnerOptions());
    this.element = $(element);
    this.$newsletterListItem = this.element.find("li");
    this.setUpEvents();
  }

  setUpEvents() {
    if (
      this.element.html().length > 0 &&
      this.element.html().indexOf("newsletterList") >= 0
    ) {
      this.element.addClass("show");
    } else {
      this.element.removeClass("show");
    }
    var self = this;
    this.$newsletterListItem.find("label").on("click", function(e) {   
      self.check(this.parentElement);
    });

    this.$newsletterListItem.find('input[type="checkbox"]').on('keydown', function(e){
      if(e.keyCode === 32){
        self.check(this.parentElement);
      }
    })

    this.element.addClass('initiated');

    this.element.find(".signIn").on("click", function(e) {
      var url = "/Sign-in"; //$(this).attr('href'); hardcoded since may launch popup then close and launch again
      var n = self.collectChecks();
      if (n != "") {
        $(this).attr("href", `${url}?nlw=${n}`);
      } else {
        $(this).attr("href", url);
      }
    });
  }

  check(list) {
    if (!$(list).hasClass("checked")) {
      this.sendRequestToSubscription(list);
    } else {
      this.removeFromSubscription(list);
    }
  }

  uncheck(list) {
    if ($(list).hasClass("checked")) {
      $(list).removeClass("checked");
    }
    if ($(list).find(".added").length) {
      $(list)
        .find(".added")
        .remove();
    }
  }
  createNewitem(list) {
    var $addedSpan = "<span class='added'> - Added</span>";
    if (!$(list).find(".added").length) {
      $(list)
        .find(".newsTitle")
        .append($addedSpan);
    }
  }
  collectChecks() {
    var list = "";
    var item = $(this.$newsletterListItem);

    item.each(function(i) {
      if ($(this).hasClass("checked")) {
        if (list == "") {
          list = $(this)
            .find("input")
            .attr("data-id");
        } else {
          list +=
            "," +
            $(this)
              .find("input")
              .attr("data-id");
        }
      } else {
        return;
      }
    });

    return list;
  }
  sendRequestToSubscription(list) {
    var self = this;
    var id = $(list)
      .find('input[type="checkbox"]')
      .attr("data-id");

    $.ajax({
      url: `/AJAX/Widgets/adnewsletterwidget.ashx?nlcode=${id}`,
      cache: false,
      beforeSend: function() {
        self.spinner = new SpinnerClass(self.element.find(".newsletterList"), {
          spinnerOptions: {
            color: "#000",
            length: 4,
            width: 3,
            radius: 7
          }
        });
        self.element.addClass(self.options.classes.loaderClass);
      }
    }).done(function(data, status, xhr) {
      self.element.removeClass("loading");
      self.spinner.hide();
      if (status == "success" || data == "OK") {
        $(list).addClass("checked");
        if (
          $(list)
            .parent()
            .hasClass("signedIn")
        ) {
          self.createNewitem(list);
        }
      }
    });
  }

  removeFromSubscription(list) {
    var self = this;
    var id = $(list)
      .find('input[type="checkbox"]')
      .attr("data-id");

    $.ajax({
      url: `/AJAX/Widgets/adnewsletterwidget.ashx?nlcode=${id}&mode=0`,
      cache: false,
      beforeSend: function() {
        self.spinner = new SpinnerClass(self.element.find(".newsletterList"), {
          spinnerOptions: {
            color: "#000",
            length: 4,
            width: 3,
            radius: 7
          }
        });
        self.element.addClass(self.options.classes.loaderClass);
      }
    }).done(function(data, status, xhr) {
      self.element.removeClass("loading");
      self.spinner.hide();
      if (status == "success" || data == "OK") {
        self.uncheck(list);
      }
    });
  }
}

export { NewsletterSignup };



// WEBPACK FOOTER //
// ./Javascript/core/classes/newsletter/newsletter-signup.class.js